module.exports = __webpack_public_path__ + "static/media/2026_WA-Footy-Lives-Here-Banner-Mobile-@1x.6ef2bc1c.webp";